import { render, staticRenderFns } from "./Postreport.vue?vue&type=template&id=5b70e8b6&scoped=true"
import script from "./Postreport.vue?vue&type=script&lang=js"
export * from "./Postreport.vue?vue&type=script&lang=js"
import style0 from "./Postreport.vue?vue&type=style&index=0&id=5b70e8b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70e8b6",
  null
  
)

export default component.exports